import React, { useState } from 'react';
import MainToolbar from '../MainToolbar';
import { TableContainer, Table, TableRow, TableCell, TableHead, TableBody, makeStyles, IconButton, Paper } from '@material-ui/core';
import t from '../common/localization';
import { useEffectAsync } from '../reactHelper';
import EditCollectionView from '../EditCollectionView';
import EditIcon from '@material-ui/icons/Edit';
import ClearIcon from '@material-ui/icons/Clear';
import { green, blue, red, grey } from '@material-ui/core/colors';
import Avatar from "@material-ui/core/Avatar";
import { showLoaderStateActions } from "./../store";
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles(theme => ({
  columnAction: {
    width: theme.spacing(1),
    padding: theme.spacing(0, 1),
  },
  tableAction: {
      backgroundColor: 'white',
    },
    rowAction: {
       backgroundColor: '#361DDB',
    },
   iconButtons: {
          display: 'flex',
          margin: theme.spacing(0.5),
    },
    small: {
        width: theme.spacing(4),
        height: theme.spacing(4),
        backgroundColor:'#EFEFEF',
        margin: '2px'
      },
      tableRow: {
            "&$hover:hover": {
            backgroundColor: "#FFFFFF"
            }
          },
}));

const DriversView = ({ updateTimestamp, onMenuClick, handleOnEdit, handleOnRemove }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [successDialogShow, setSuccessDialogShow] = useState(false);

  const [items, setItems] = useState([]);

  useEffectAsync(async () => {
        dispatch(showLoaderStateActions.addState(true));

    const response = await fetch('/api/drivers');
                        dispatch(showLoaderStateActions.addState(false));
    if (response.ok) {
      setItems(await response.json());
    }
  }, [updateTimestamp]);

  return (
    <TableContainer component={Paper}>
    <Table  className={classes.tableAction} size="small" >
      <TableHead>
        <TableRow className={classes.rowAction} >
          <TableCell style={{ color: "white"}}>{t('sharedName')}</TableCell>
          <TableCell style={{ color: "white"}}>{t('uniqueId')}</TableCell>
          <TableCell className={classes.columnAction} />
        </TableRow>
      </TableHead>
      <TableBody>
        {items.map((item) => (
          <TableRow
          hover
          key={item.id}
          className={classes.tableRow}>

            <TableCell><b>{item.name}</b></TableCell>
            <TableCell>{item.uniqueId}</TableCell>
            <TableCell className={classes.columnAction}>
            <div className={classes.iconButtons}>
                                                              <Avatar className={classes.small}>
                                                              {<IconButton onClick={(event) => handleOnEdit(item.id)}>
                                                               <EditIcon fontSize="small" style={{ color: blue[600] }}/>
                                                              </IconButton>}
                                                              </Avatar>
                                                              <Avatar className={classes.small}>
                                                              {<IconButton onClick={(event) => handleOnRemove(item.id)}>
                                                               <ClearIcon fontSize="small" style={{ color: grey[450] }}/>
                                                              </IconButton>}
                                                              </Avatar>
                                                              </div>
          </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
    </TableContainer>
  );
}

const DriversPage = () => {
  return (
    <>
      <MainToolbar />
      <EditCollectionView content={DriversView} editPath="/settings/driver" endpoint="drivers"
                     successDialogShow={false}
/>
    </>
  );
}

export default DriversPage;
